import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EFArrowRight from 'elem/ui-assets/icons/common/EFArrowRight';
import EfEmarsysEmail from 'elem/ui/ef-emarsys-email';
import EfImg from 'elem/ui/ef-img';
import EfLink from 'elem/ui/ef-link';
import EfModal from 'elem/ui/ef-modal';
import EfSpec from 'elem/ui/ef-spec';
import EfTitle from 'elem/ui/ef-title';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useProductStore } from './../../../ProductProvider';
import { imgLocaleA, imgLocaleB, imgLocaleC, imgLocaleD } from './Imgs';
import styles from './index.module.scss';
import { EU_STATUSB_CARDS } from './comon';
import { getSolarRecommand } from '@/service/solar-calculator';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us', query } = useRouter();
    const { pageStatus } = useProductStore();
    const [gap, setGap] = useState(16);
    const IS_NA_SITES = ['us', 'ca', 'br', 'mx'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph', 'nl'].includes(locale);
    const IS_STATUSB = pageStatus === 'statusB';
    const [showModal, setShowModal] = useState(false);
    const imgA = imgLocaleA[locale] || imgLocaleA['us'];
    const imgB = imgLocaleB[locale] || imgLocaleB['us'];
    const imgC = imgLocaleC[locale] || imgLocaleC['us'];
    const imgD = imgLocaleD[locale] || imgLocaleD['us'];

    const isTimeOut = () => {
        const now = query._timer ? new Date(query?._timer as string) : new Date();
        // de 提前上
        const targetDate = new Date(locale === 'de' ? '2024/12/10 15:00:00 GMT+8' : '2024/12/19 15:00:00 GMT+8');
        if (now < targetDate) {
            return true;
        }
        return false;
    };

    const IS_EU_STATUSB = IS_EU_SITES && IS_STATUSB;
    const [cards, setCards] = useState([
        {
            label: IS_NA_SITES
                ? pageStatus === 'statusA'
                    ? t('NA1_card1_labelA')
                    : ['statusB', 'statusC'].includes(pageStatus)
                    ? t('NA1_card1_labelB')
                    : ''
                : '',
            title: IS_EU_STATUSB ? EU_STATUSB_CARDS[locale][0].title : t('NA1_card1_title'),
            subtitle: IS_EU_STATUSB ? EU_STATUSB_CARDS[locale][0].subtitle : t('NA1_card1_subtitle'),
            desc: IS_EU_STATUSB ? EU_STATUSB_CARDS[locale][0].desc : t('NA1_card1_desc'),
            launch: IS_EU_STATUSB ? (isTimeOut() ? EU_STATUSB_CARDS[locale][0].launch : undefined) : t('NA1_card1_launch'),
            img: imgC.pc,
            productId: (() => {
                const LocalMap: any = {
                    uk: '9616877420883',
                    de: '14848608960847',
                    fr: '9594942095707',
                    it: '14845588341112',
                    es: '9594953924955',
                    eu: '9744704930135',
                    ph: '10084084318518',
                    nl: '9935710978324',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            // 假数据
            variantId: (() => {
                const LocalMap: any = {
                    us: '41631662145609',
                    ca: '45159091077274',
                    uk: '49833568993619',
                    de: '53707200004431',
                    fr: '49526901866843',
                    it: '54819109306744',
                    es: '49526969139547',
                    eu: '49573797593431',
                    ph: '52064529219894',
                    nl: '51194415317268',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            link_more: (() => {
                const links = {
                    us: 'https://us.ecoflow.com/products/delta-3-series-portable-power-station?variant=41631662145609',
                    ca: 'https://ca.ecoflow.com/products/delta-3-series-portable-power-station?variant=45159091077274',
                };
                return links[locale] || '';
            })(),

            buy_now_text: IS_EU_STATUSB
                ? (() => {
                      const BuyNowMap: any = {
                          uk: 'Buy Now',
                          eu: 'Buy Now',
                          de: 'Jetzt kaufen',
                          es: 'Comprar ahora',
                          fr: 'Acheter maintenant',
                          it: 'Acquista ora',
                          ph: 'Buy Now',
                          nl: 'Koop nu',
                      };
                      return BuyNowMap[locale] || BuyNowMap.eu;
                  })()
                : t('common_buy'),
        },
        {
            label: IS_NA_SITES
                ? pageStatus === 'statusA'
                    ? t('NA1_card2_labelA')
                    : ['statusB', 'statusC'].includes(pageStatus)
                    ? t('NA1_card2_labelB')
                    : ''
                : '',
            title: IS_EU_STATUSB ? EU_STATUSB_CARDS[locale][1].title : t('NA1_card2_title'),
            subtitle: IS_EU_STATUSB ? EU_STATUSB_CARDS[locale][1].subtitle : t('NA1_card2_subtitle'),
            desc: IS_EU_STATUSB ? EU_STATUSB_CARDS[locale][1].desc : t('NA1_card2_desc'),
            launch: IS_EU_STATUSB ? (isTimeOut() ? EU_STATUSB_CARDS[locale][1].launch : undefined) : t('NA1_card1_launch'),
            img: imgD.pc,
            productId: (() => {
                const LocalMap: any = {
                    uk: '9616877420883',
                    de: '14848608960847',
                    fr: '9594942095707',
                    it: '14845588341112',
                    es: '9594953924955',
                    eu: '9744704930135',
                    nl: '9935710978324',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            // 假数据
            variantId: (() => {
                const LocalMap: any = {
                    us: '41631710281801',
                    ca: '45159091142810',
                    uk: '49833568895315',
                    de: '53707199873359',
                    fr: '49526901768539',
                    it: '54819109208440',
                    es: '49526969041243',
                    eu: '49573797495127',
                    nl: '51194415120660',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            link_more: (() => {
                const links = {
                    us: 'https://us.ecoflow.com/products/delta-3-series-portable-power-station?variant=41631710281801',
                    ca: 'https://ca.ecoflow.com/products/delta-3-series-portable-power-station?variant=45159091142810',
                };
                return links[locale] || '';
            })(),

            buy_now_text: IS_EU_STATUSB
                ? (() => {
                      const BuyNowMap: any = {
                          uk: 'Buy Now',
                          eu: 'Buy Now',
                          de: 'Jetzt kaufen',
                          es: 'Comprar ahora',
                          fr: 'Acheter maintenant',
                          it: 'Acquista ora',
                          ph: 'Buy Now',
                          nl: 'Koop nu',
                      };
                      return BuyNowMap[locale] || BuyNowMap.eu;
                  })()
                : t('common_buy'),
        },
    ]);

    const filedsMap = {
        eu: {
            contactListId: ['324184408'],
            fields: [
                {
                    id: '4427',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '7596',
                    type: 'multiple',
                    value: [28],
                    overwrite: false,
                },
                {
                    id: '9690',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
            ],
        },
        uk: {
            contactListId: ['16182394'],
            fields: [
                {
                    id: '4430',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '7596',
                    type: 'multiple',
                    value: [28],
                    overwrite: false,
                },
                {
                    id: '9690',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
            ],
        },
        de: {
            contactListId: ['236549250'],
            fields: [
                {
                    id: '4425',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '7596',
                    type: 'multiple',
                    value: [28],
                    overwrite: false,
                },
                {
                    id: '9690',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
            ],
        },
        fr: {
            contactListId: ['1053269597'],
            fields: [
                {
                    id: '4428',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '7596',
                    type: 'multiple',
                    value: [28],
                    overwrite: false,
                },
                {
                    id: '9690',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
            ],
        },
        it: {
            contactListId: ['1998934371'],
            fields: [
                {
                    id: '4429',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '7596',
                    type: 'multiple',
                    value: [28],
                    overwrite: false,
                },
                {
                    id: '9690',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
            ],
        },
        es: {
            contactListId: ['1772671024'],
            fields: [
                {
                    id: '4426',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '7596',
                    type: 'multiple',
                    value: [28],
                    overwrite: false,
                },
                {
                    id: '9690',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
            ],
        },
    };

    const linksMap = {
        eu: 'https://bit.ly/3LYt08G',
        nl: 'https://bit.ly/3LYt08G',
        de: 'https://bit.ly/3LYt08G',
        fr: 'https://bit.ly/3W6Yj76',
        uk: 'https://bit.ly/3Ywp6eR',
        it: 'https://bit.ly/3Ajlp23',
    };

    const configs = {
        className: 'email-box',
        needTerms: true,
        isMulti: true,
        langKey: 'delta3series',
        termsHtml: (() => {
            const terms = {
                eu: "I consent to the <a href='https://eu.ecoflow.com/policies/terms-of-service' target='_blank'>Terms of Use</a> and <a href='https://eu.ecoflow.com/policies/privacy-policy' target='_blank'>Privacy Policy</a>.",
                uk: "I consent to the <a href='https://uk.ecoflow.com/policies/terms-of-service' target='_blank'>Terms of Use</a> and <a href='https://uk.ecoflow.com/policies/privacy-policy' target='_blank'>Privacy Policy</a>.",
                de: "Ich stimme den <a href='https://de.ecoflow.com/policies/terms-of-service' target='_blank'>Nutzungsbedingungen</a> und der <a href='https://de.ecoflow.com/policies/privacy-policy' target='_blank'>Datenschutzrichtlinie</a> zu.",
                fr: "J'accepte les <a href='https://fr.ecoflow.com/policies/terms-of-service' target='_blank'>Conditions d'utilisation</a> et la <a href='https://fr.ecoflow.com/policies/privacy-policy' target='_blank'>Politique de confidentialité</a>.",
                it: "Acconsento ai <a href='https://it.ecoflow.com/policies/terms-of-service' target='_blank'>Termini di utilizzo</a> e <a href='https://it.ecoflow.com/policies/privacy-policy' target='_blank'>all’Informativa sulla privacy</a>.",
                es: "Acepto los <a href='https://es.ecoflow.com/policies/terms-of-service' target='_blank'>Términos de uso</a> y la <a href='https://es.ecoflow.com/policies/privacy-policy' target='_blank'>Política de privacidad</a>.",
            };
            return terms[locale] || '';
        })(),
        tipsObj: {
            btnText: t('NA2_email_btn') || t('NA1_email_btn'),
            placeholder: t('NA2_email_placeholder') || t('NA1_email_placeholder'),
            // tipsEmpty: 'Please enter the email.',
            // tipsTypeError: 'Please enter a valid email address.',
            // successTips: 'Subscription successful !',
        },
        callback: (statu: 'fail' | 'success') => {
            setShowModal(statu === 'success');
        },
        ...filedsMap[locale],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1024 && window.innerWidth <= 1440 ? 12 : 16);
        }
    }, []);

    // 获取产品信息
    useEffect(() => {
        if (!['eu', 'de', 'es', 'fr', 'it', 'uk', 'nl'].includes(locale)) return;

        if (isTimeOut()) return;
        const getAsynItem = async (productId: string, variantId: string) => {
            return await getSolarRecommand({ productId, variantId }, locale);
        };
        Promise.all(cards.map((i) => getAsynItem(i.productId, i.variantId))).then((res) => {
            const newCards = cards.map((i, idx) => {
                if (res[idx].data.skuTitle) {
                    return { ...i, img: res[idx]?.data?.variantImg, title: res[idx].data.skuTitle };
                }
                return i;
            });

            setCards(newCards);
        });
    }, [locale]);

    return (
        <div className={styles.TheComp}>
            {!IS_EU_SITES && <EfSpec className="spec-x" />}
            {IS_EU_SITES && <EfTitle>{IS_STATUSB ? t('NA1_title2') : t('NA1_title')}</EfTitle>}
            <div className={`info-box ${IS_EU_SITES ? 'eu' : ''}`}>
                <EfIcon pc={imgA.pc} className="SGS2" />
                <p className="desc">{IS_EU_SITES && IS_STATUSB ? t('NA1_desc2') : t('NA1_desc')}</p>
            </div>
            {!IS_NA_SITES && (
                <Swiper className={`cards ${IS_EU_SITES ? 'eu' : ''}`} spaceBetween={gap} slidesPerView={'auto'} initialSlide={0}>
                    {cards?.map((card: any, k: number) => (
                        <SwiperSlide className="card" key={k}>
                            <div className="card-img">
                                <EfImg pc={card.img} />
                            </div>
                            <div className="card-info">
                                {card?.label && <p className="card-label">{card?.label}</p>}
                                {card?.title && <p className="card-title">{card?.title}</p>}
                                {card?.subtitle && <p className="card-subtitle">{card?.subtitle}</p>}
                                {card?.desc && <p className="card-desc">{card?.desc}</p>}
                                {card?.launch && <p className="card-launch">{card?.launch}</p>}

                                {IS_EU_STATUSB && !isTimeOut() && (
                                    <div className="card-links">
                                        <EfLink
                                            href={`https://${locale}.ecoflow.com/cart/${card.variantId}:1?channel=buy_button`}
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'buy',
                                                product_name: card?.title,
                                                position: `Product ${card?.title}`,
                                            }}
                                        >
                                            {card.buy_now_text}
                                            <EFArrowRight />
                                        </EfLink>
                                    </div>
                                )}
                                {pageStatus === 'statusD' && IS_NA_SITES && (
                                    <div className="card-links">
                                        <EfLink
                                            href={card?.link_more}
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'buy',
                                                product_name: card?.title,
                                                position: card?.title,
                                            }}
                                        >
                                            {t('common_more')}
                                            <EFArrowRight />
                                        </EfLink>
                                        <EfLink
                                            href={`https://${locale}.ecoflow.com/cart/${card.variantId}:1?channel=buy_button`}
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'checkout',
                                                button_name: `${card.buy_now_text}_${card?.title}`,
                                            }}
                                        >
                                            {card.buy_now_text}
                                            <EFArrowRight />
                                        </EfLink>
                                    </div>
                                )}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
            {IS_EU_SITES && isTimeOut() && (
                <div className="email-wrapper" id="delta3-subsrcibe-eu">
                    <EfImg pc={imgB.pc} pad={imgB.pad} h5={imgB.h5} />
                    <div className="email-info">
                        <p className="email-title">
                            {t.rich('NA1_email_title', {
                                o: (tx: string) => <span className="o">{tx}</span>,
                            })}
                        </p>
                        <EfEmarsysEmail {...configs} />
                    </div>
                </div>
            )}
            {!IS_EU_SITES && <EfSpec className="spec-x" />}
            {showModal && (
                <EfModal open={showModal} title="" position="center" callback={() => setShowModal(false)}>
                    <p className="modal-title">{t('NA1_email_success_title')}</p>
                    {['de', 'fr', 'uk', 'it'].includes(locale) && (
                        <EfLink className="modal-btn" href={linksMap[locale] || ''}>
                            {t('NA1_email_success_btn')}
                        </EfLink>
                    )}
                </EfModal>
            )}
            {IS_EU_SITES && <EfSpec className="spec-x" />}
        </div>
    );
}
